import { getI18n, useTranslation } from "react-i18next";
import styled from "styled-components";
import React, { Fragment, useCallback } from "react";
import { iTxt, CONTENT_MANAGEMENT_ID, useRedirect } from "@duosoftbg/nacid-components";
import PageWrapper from "../../components/common/layout/PageWrapper";
import useViewDataObject from "../../../hooks/redux/useViewDataObject";
import { VIEW_TYPES } from "../../../config/view/types";
import { getContentManagementDataById } from "../../../axios/api/services";
import ViewPageWrapper from "../contacts/ViewPageWrapper";

const MainGroupTxt = styled.div`
  font-weight: bold;
  color: #4679b2;
  margin-bottom: 25px;
  margin-top: 25px;
  font-size: 20px;
`;

const SubGroupTxt = styled.div`
  margin-bottom: 10px;
`;

const SubGroupWrapper = styled.div`
  margin-bottom: 35px;
`;

const SiteMapLinkDiv = styled.div`
  margin-bottom: 10px;
`;

const SiteMapLink = styled.a`
  margin-left: 15px;
  color: ${(props) => props.theme.palette.primary.light};

  :hover {
    color: black;
    text-decoration: underline;
  }
`;

const SiteMap = () => {
  const { t } = useTranslation();

  const viewType = VIEW_TYPES.SITEMAP;
  const { object, data: siteMap } = useViewDataObject(viewType);
  const serviceFn = useCallback(getContentManagementDataById(CONTENT_MANAGEMENT_ID.SITEMAP), []);
  const { redirect } = useRedirect();

  return (
    <PageWrapper title={t("t.page.sitemap")}>
      <ViewPageWrapper viewType={viewType} serviceFn={serviceFn} object={object}>
        {siteMap &&
          siteMap.map((item) => (
            <Fragment key={"main-group-fragment-" + item.mainGroup.id}>
              <MainGroupTxt key={"main-group-txt-" + item.mainGroup.id}>
                {iTxt(getI18n().language, item.mainGroup.name, item.mainGroup.nameEn)}
              </MainGroupTxt>
              {item.subGroups.map((subGroup) => (
                <SubGroupWrapper key={"sub-group-wrapper-" + subGroup.id}>
                  <SubGroupTxt key={"sub-group-txt-" + subGroup.id}>
                    {iTxt(getI18n().language, subGroup.name, subGroup.nameEn)}
                  </SubGroupTxt>
                  {subGroup.links.map((link) => (
                    <SiteMapLinkDiv key={"site-map-link-div-" + link.link}>
                      <SiteMapLink
                        onClick={() => {
                          redirect(link.link);
                        }}
                        key={"site-map-link-" + link.link}
                      >
                        {iTxt(getI18n().language, link.name, link.nameEn)}
                      </SiteMapLink>
                    </SiteMapLinkDiv>
                  ))}
                </SubGroupWrapper>
              ))}
            </Fragment>
          ))}
      </ViewPageWrapper>
    </PageWrapper>
  );
};

export default SiteMap;
